import { USERNAME_SESSION_KEY } from "./login.actions";
import { getParameterByName } from "../../../utils/urlParser";
import { loginInitialState } from "./login.types";

const cachedUsername = sessionStorage.getItem(USERNAME_SESSION_KEY) || "";

const returnUrl = getParameterByName("returnUrl");
const passedUsername = decodeURIComponent(getParameterByName("username"));

export const initialState: loginInitialState = {
	isFetching: false,
	usernameExists: !!cachedUsername || !!passedUsername,
	alerts: [],
	form: {
		email: cachedUsername || passedUsername,
		password: "",
		returnUrl,
	},
};
